import SuperInstant from "@Components/NewUI/Common/SuperInstant";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import collateral from "../../../../../../src/Images/NewUI/collateral.png";
import cyclicImg from "../../../../../../src/Images/NewUI/cycle.png";
import paperlessimg from "../../../../../../src/Images/NewUI/paperless.png";
import PersonalLoan from "../../../../../../src/Images/NewUI/personalloan.png";
import SparkHere from "../../../../../../src/Images/NewUI/sparkhere.png";
import PersonalLoansuperapp from "../../../../../../src/Images/NewUI/super-app-loan.png";
import WhiteSpark from "../../../../../../src/Images/NewUI/whiteSpark.png";
// Removed - no longer needed as data comes from props
// import { loanStatusApi } from "../../../../../Redux/ApplyLoan/action";
// import {
//   getGenralUserDetail,
//   getUserDetail,
// } from "../../../../../Redux/GeneralDetails/action";
// import { getDocumentStatus } from "../../../../../Redux/Manual_Kyc_Details/action";
import UnderReview from "./UnderReview";
// import ToastMsg from '../../../../../../src/helper/ToastMsg';

const LoanMain = (props) => {
  const [emi, setEmi] = useState(false);
  const [credit_model, setCredit_model] = useState({});
  const [amount, setAmount] = useState("0");
  const [loanType, setLoanType] = useState("");
  const [credit, setCredit] = useState();
  const [isCivilform, setIsCivilform] = useState("");
  const [personal_info, setPersonal_info] = useState("");
  const [paydayAmount, setPaydayAmount] = useState("");
  const [emiMonth, setEmiMonth] = useState("");
  const [emiAmount, setEmiAmount] = useState("");
  const [can_apply_for_loan, setCan_apply_for_loan] = useState("");
  const [userbankdetail, setUserbankdetail] = useState("");
  const [bank_details_verified, setBank_details_verified] = useState("");
  const [isblockeduser, setIsblockeduser] = useState("");
  const [isCanApply, setIsCanApply] = useState(false);
  const [isCibilForm, setIsCibilForm] = useState(false);
  const [userType, setUserType] = useState("");
  const [isLimitAssigned, setisLimitAssigned] = useState(false);
  const [loanAmount, setLoanAmount] = useState("");
  const [loanStatuspass, setloanStatus] = useState({});
  const [openSuperIntent, setOpenSuperIntent] = useState(false);
 

  const check = (passedArray) => {
    let status = "";
    let index = 0;
    let credit_limit = 0;

    for (let i = 0; i <= passedArray?.length; i++) {
      if (passedArray[i]?.loan_type !== "P") {
        status = "E";
        if (passedArray[i]?.credit_limit > credit_limit) {
          index = i;
          credit_limit = passedArray[i]?.credit_limit;
        }
      } else {
        if (status !== "E") {
          index = i;
        }
      }
    }
    console.log(index, "index");
    return index;
  };

  useEffect(() => {
    // Use props data instead of making API calls
    if (props.userDetail) {
      const personal_info = props.userDetail;
      if (personal_info?.usercredit?.length > 0) {
        const creditData = personal_info.usercredit[check(personal_info.usercredit)];
        setCredit_model(creditData);
        setAmount(creditData?.credit_limit || "0");
        setLoanType(creditData?.loan_type || "");
        setEmi(creditData?.loan_type !== "P");
        
        let maxemiamount = 0;
        personal_info.usercredit.map((usercredit) => {
          if (usercredit.loan_type === "P") {
            setPaydayAmount(usercredit.credit_limit);
          } else {
            if (usercredit.credit_limit > maxemiamount) {
              maxemiamount = usercredit.credit_limit;
              let myArray = usercredit.loan_type.split("");
              setEmiMonth(myArray[1]);
            }
            setEmiAmount(maxemiamount);
          }
        });
      }
      setPersonal_info(personal_info);
      setCan_apply_for_loan(personal_info?.can_apply_for_loan);
    }
    
    if (props.loanStatusData) {
      setloanStatus(props.loanStatusData);
      setisLimitAssigned(props.loanStatusData?.amount > 0);
      setLoanAmount(props.loanStatusData?.amount);
      if (!props.loanStatusData?.loan_status || 
          props.loanStatusData?.loan_status === "PASSED" || 
          props.loanStatusData?.loan_status === null) {
        setOpenSuperIntent(true);
      }
    }
    
    if (props.documentStatus) {
      setIsCanApply(props.documentStatus?.can_apply_for_loan);
      setIsCibilForm(props.documentStatus?.cibil_form);
      setIsblockeduser(props.documentStatus?.blocked);
      setUserType(props.documentStatus?.user_type);
    }
    
    if (props.credit) {
      setCredit(props.credit);
    }
  }, [props.userDetail, props.loanStatusData, props.documentStatus, props.credit]);

  // Removed - data now comes from props

  // Removed - data now comes from props

  const handlecreditlimitredirection = () => {
    const btnNameinput = "GET_NOW";
    window.location.href = "/creditlimit";
    history.push(`/creditlimit`);
  };
  // Removed - data now comes from props
  const handleapplynow = () => {
    
    window.location.href = "/completeprofilenew";
  };
  return (
    <>
      {!isCibilForm ? (
        isCanApply ||
        loanStatuspass?.loan_status === "PASSED" ||
        loanStatuspass?.loan_status === null ? (
          // && !isCibilForm
          <div className="mt45d">
            <SuperInstant
              flag={true}
              credit={credit_model}
              amount={amount}
              statusEmi={emi}
              loanType={loanType}
              topCoverState={false}
              loanStatus={loanStatuspass}
              event={"dash"}
              documentStatus={props.documentStatus}
              loanStatusData={props.loanStatusData}
            />
          </div>
        ) : (
          <UnderReview />
        )
      ) : (
        <div className="cardstructure-super-app container-super-app">
          {!isblockeduser && (
            <img
              width={126}
              height={28}
              src={PersonalLoansuperapp}
              className="superapplable"
            />
          )}

          <div className="flex_row justifycontent pd-top-20">
            <div className="flex_row">
              <div style={{ marginRight: 5, marginTop: 12 }}>
                <img
                  className="collatral2lac"
                  width={28}
                  height={28}
                  src={PersonalLoan}
                />
              </div>

              <div className="majorAmountdiv-superapponetime">
                <span className="uptospan">
                  {emiAmount === 0 ? (
                    <span className="superSpanSmall">Up to</span>
                  ) : null}
                </span>
                <br />
                <div className="superSpanSmall uptodashboardfix">Up to</div>
                <span className="#">
                  <span
                    style={{ fontWeight: "700", fontSize: "28px" }}
                    className="transformFix"
                  >
                    <span className="rupeEsign">₹</span> 2,00,000
                  </span>
                </span>
                <br />
                <div className="flex_row"></div>
              </div>
            </div>
          </div>

          <div className="cardgreencontent">
            <div className="flex_col alignflexstart">
              <div className="text-design nocollatrol">
                <img
                  src={collateral}
                  style={{ marginRight: "5px", marginBottom: "3px" }}
                  height={16}
                  width={16}
                />
                <span>
                  No collateral{" "}
                  <span className="superapp-blacktext">Required</span>
                </span>
              </div>
              <div className="text-design">
                <img
                  src={cyclicImg}
                  style={{ marginRight: "5px", marginBottom: "3px" }}
                  height={16}
                  width={16}
                />
                <span>
                  3-4 Minutes{" "}
                  <span className="superapp-blacktext">Processing time</span>
                </span>
              </div>
            </div>
            <div className="displayfix">
              <div className="onetimePayment-superapp ">
                <span className="paperless">Instant</span>
                <img
                  src={SparkHere}
                  style={{ marginLeft: "5px", marginBottom: "2px" }}
                  height={14}
                  width={7}
                />
              </div>

              <div className="onetimePayment-superapp ">
                <span className="paperless">Paperless</span>
                <img
                  src={paperlessimg}
                  style={{ marginLeft: "3px" }}
                  height={14}
                  width={14}
                />
              </div>
            </div>
          </div>
          <div
            onClick={
              isCivilform ? handleapplynow : handlecreditlimitredirection
            }
            className="super-app-btn"
          >
            <span>Get Now</span>
            <img
              src={WhiteSpark}
              style={{ marginLeft: "3px" }}
              height={22}
              width={12}
            />
          </div>
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps)(LoanMain);
